import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Locale unique pour dates/heures côté site (fuseau : navigateur / Europe par défaut). */
export const APP_LOCALE = 'fr-BE';

/** Options Intl pour heures toujours en 24 h (évite tout format AM/PM). */
export const TIME_24H = { hour: '2-digit', minute: '2-digit', hour12: false };

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString(APP_LOCALE, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}

/** Date du jour civil à Bruxelles (libellé long), pour les événements UTA. */
export function formatDateBrussels(isoOrDate) {
    if (!isoOrDate) return '';
    const d = new Date(isoOrDate);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(APP_LOCALE, {
        timeZone: 'Europe/Brussels',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}

/** Date + heure locale, format 24 h (ex. pour libellés complets). */
export function formatDateTimeFr(isoOrDate) {
    if (!isoOrDate) return '';
    const d = new Date(isoOrDate);
    if (Number.isNaN(d.getTime())) return '';
    const datePart = d.toLocaleDateString(APP_LOCALE, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    const timePart = d.toLocaleTimeString(APP_LOCALE, TIME_24H);
    return `${datePart} à ${timePart}`;
}

/** Début du jour calendaire local (minuit) en timestamp, pour comparaisons « passé / à venir ». */
export function getStartOfLocalDay(ref = new Date()) {
    const d = new Date(ref);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
}

/** L’instant de l’événement est-il avant aujourd’hui (jour civil local) ? */
export function isEventDateInPast(isoOrDate) {
    const t = new Date(isoOrDate).getTime();
    if (Number.isNaN(t)) return false;
    return t < getStartOfLocalDay();
}

